<template>
  <Modal title="解绑学导" v-model="visible">
    <Form ref="assignAdviserForm" class="form"
          :model="adviserParam" :rules="adviserRule"
          :label-width="80">
      <Row>
        <Col :span="22">
        <Form-item label="学生">
          <Tag v-for="item in userList" :key="item.id" :name="item.id" >
            {{ item.id + ' - ' + item.nickname }}
          </Tag>
        </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingAssignAdviser" @click="assignAdviser">解绑</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: 'AssignAdvierTreModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      userList: {
        type: Array
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        visible: this.value,
        loadingAssignAdviser: false,
        adviserParam: {
          adviserId: '',
          resourceStatus: 2
        },
      }
    },
    methods: {
      assignAdviser () {
        let self = this

        let idList = self.userList.map(function (element) {
          return element.id
        })
        self.loadingAssignAdviser = true
        let params = {ids: idList.join(',')}
        self.$http.get('/user/UnBinStudy', {params: params}).then(function (res) {
          if (res && res.data > 0) {
            self.successCallback()
            self.visible = false
          }
          self.loadingAssignAdviser = false
        }).catch(function (e) {
          self.visible = false
          self.loadingAssignAdviser = false
        })
      }
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        if (val === false) {
          this.adviserParam.adviserId = ''
        }
        this.$emit('input', val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// UnBinStudyModal.vue?30e20b7d